import { CHART_SHADE, mantineColorVar } from '#core/lib/formatters/colors.ts';

/** Type-of-text styling shared by the plain axis-title config and the SVG `AxisTitle` renderer. */
export const AXIS_TITLE_STYLE = {
  fontSize: 'var(--mantine-font-size-xs)',
  fill: mantineColorVar('dark', CHART_SHADE.axisTitle),
} as const;
/**
 * Width (px) of the margin strip the chart reserves, outside the axis
 * band, for a rotated (side) axis title. The title is drawn in this
 * strip — a disjoint x-region from the auto-fit tick band — so the two
 * can never overlap regardless of tick magnitude. Shared by
 * `CartesianChart`'s margin and `AxisTitle`'s rotated anchor so the
 * reservation and the placement stay in lockstep.
 */
export const AXIS_TITLE_RESERVE = 24;
